<div class="flex flex-col md:flex-row min-h-screen m-0 p-0 overflow-y-auto">
  <!-- Left Section (Login Form) -->
  <div class="w-full md:w-1/2 flex items-center justify-center login-left px-8 py-12 md:py-12">
    <div class="w-full max-w-sm login-form-container">
      <!-- Logo -->
      <div class="mb-8">
        <app-botmaa></app-botmaa>
      </div>

      <!-- Login Form -->
      <form [formGroup]="loginForm" (ngSubmit)="handleSubmit()" class="space-y-4 login-form">
        <!-- Email/Username/Mobile Number -->
        <app-form-field
          #emailField
          label="Email / Mobile Number"
          id="email"
          type="text"
          placeholder="Email / Mobile Number"
          [formControl]="$any(loginForm.get('email'))"
        ></app-form-field>

        <!-- Password -->
        <app-password-input
          #passwordField
          label="Password"
          id="password"
          placeholder="Password"
          [formControl]="$any(loginForm.get('password'))"
        ></app-password-input>

        <!-- Remember Me and Forgot Password -->
        <div class="login-options">
          <label class="remember-me">
            <input
              #rememberMeCheckbox
              type="checkbox"
              [checked]="rememberMeChecked"
              (change)="onRememberMeChange($event)"
            />
            <span>Remember me</span>
          </label>
          <a routerLink="/reset-password" class="forgot-password-link">Forgot Password?</a>
        </div>

        <!-- Resend Verification Email Link -->
        @if (showResendVerification) {
          <div class="resend-verification-container">
            <p class="resend-verification-text">
              Your email is not verified. Please check your inbox for the verification link.
            </p>
            <button
              type="button"
              (click)="handleResendVerification()"
              [disabled]="resendingVerification"
              class="resend-verification-link"
            >
              @if (resendingVerification) {
                <span>Sending...</span>
              } @else {
                <span>Resend Verification Email</span>
              }
            </button>
          </div>
        }

        <!-- Submit -->
        <div class="sign-container">
          <app-form-submit-button
            type="submit"
            [loading]="loading"
            label="Sign In"
            loadingLabel="Signing in..."
          ></app-form-submit-button>
        </div>

        <!-- Divider -->
        <app-divider></app-divider>

        <!-- Google Sign In -->
        <button
          type="button"
          (click)="handleGoogleLogin()"
          [disabled]="googleLoading"
          class="google-signin-button w-full flex items-center justify-center gap-2 border border-gray-300 py-2 rounded-md hover:bg-gray-50 transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          @if (googleLoading) {
            <svg
              class="animate-spin h-5 w-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          } @else {
            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              alt="Google Icon"
              class="h-5 w-5"
            />
          }
          <span>{{ googleLoading ? 'Connecting...' : 'Sign in with Google' }}</span>
        </button>

        <!-- Sign Up -->
        <app-auth-link
          questionText="Don't have an account?"
          linkText="Sign Up"
          linkRoute="/signup"
        ></app-auth-link>
      </form>
    </div>
  </div>

  <!-- Right Section (Welcome / Image) -->
  <div
    class="hidden md:flex w-1/2 relative items-center bg-gray-50 overflow-hidden loginBG m-0 p-0 rounded-none"
  >
    <div class="absolute inset-0 bg-white bg-opacity-0"></div>
    <!-- Top orange circle -->
    <div class="absolute top-10 left-[40px] bg-botmaaOrange h-24 w-24 rounded-full"></div>

    <!-- Content -->
    <div class="p-20 z-10 pt-0 mb-28 pl-36 pr-10">
      <div class="inline-block">
        <h2 class="welcome-subtitle text-botmaaGrey font-semibold">WELCOME TO</h2>
        <h1 class="welcome-title font-bold mb-4">Bot<span class="text-botmaaOrange">Maa</span></h1>
        <div class="flex-grow border-t border-botmaaGrey border-4 rounded-2xl mb-6"></div>
      </div>

      <p class="welcome-description text-botmaaGrey font-inter font-bold leading-[24px] tracking-[0] mb-4">
        Sign in to access Dashboard
      </p>

      <!-- Image -->
    </div>

    <!-- Bottom orange circle -->
    <div class="absolute bottom-[-35px] right-[80px] h-32 w-32 rounded-full bg-botmaaOrange"></div>
  </div>
</div>
